export const PASSWORD_MIN_LENGTH = 8;
/** Limite prático: gestores de senha e frases longas cabem; bcrypt usa até ~72 bytes. */
export const PASSWORD_MAX_LENGTH = 64;

const SPECIAL_CHAR_REGEX = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~]/;

/** Requisitos exibidos na checklist (máximo é só validação/limite de campo). */
export const PASSWORD_REQUIREMENTS = [
  {
    id: "minLength",
    label: `Mínimo de ${PASSWORD_MIN_LENGTH} caracteres`,
    test: (value) => value.length >= PASSWORD_MIN_LENGTH,
  },
  {
    id: "uppercase",
    label: "Pelo menos uma letra maiúscula",
    test: (value) => /[A-Z]/.test(value),
  },
  {
    id: "lowercase",
    label: "Pelo menos uma letra minúscula",
    test: (value) => /[a-z]/.test(value),
  },
  {
    id: "number",
    label: "Pelo menos um número",
    test: (value) => /\d/.test(value),
  },
  {
    id: "special",
    label: "Pelo menos um caractere especial (!@#$%...)",
    test: (value) => SPECIAL_CHAR_REGEX.test(value),
  },
];

export const STRENGTH_LABELS = {
  weak: "Fraca",
  fair: "Razoável",
  good: "Boa",
  strong: "Forte",
};

export const STRENGTH_COLORS = {
  weak: "#ef4444",
  fair: "#f59e0b",
  good: "#3b82f6",
  strong: "#16a34a",
};

export const evaluatePasswordStrength = (password = "") => {
  const value = String(password || "");
  const checks = PASSWORD_REQUIREMENTS.reduce((acc, rule) => {
    acc[rule.id] = rule.test(value);
    return acc;
  }, {});

  const metCount = PASSWORD_REQUIREMENTS.filter((rule) => checks[rule.id]).length;
  const lengthBonus = value.length >= 12 ? 1 : 0;
  const score = metCount + lengthBonus;

  let strength = "weak";
  if (score >= 6) strength = "strong";
  else if (score >= 5) strength = "good";
  else if (score >= 3) strength = "fair";

  const isValid = PASSWORD_REQUIREMENTS.every((rule) => checks[rule.id]);

  return {
    checks,
    score,
    strength,
    isValid,
  };
};
